var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list.length)?_c('ul',_vm._l((_vm.list),function(ref){
var lbl = ref[0];
var content = ref[1];
return _c('li',{key:lbl},[_c('strong',[_vm._v(_vm._s(_vm.titleCased(lbl))+": ")]),(_vm.isLeaf(content))?_c('span',[_vm._v(_vm._s(_vm.isType.nullOrUndef(content) ? '(empty)' : content))]):_c('json-list',{attrs:{"obj":_vm.branch(content, lbl)}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }